import React, {
    useRef, useCallback, useEffect, useState,
} from 'react';

import classNames from 'classnames';
import { MediaContentContext, OnClickOpenDetails } from './dishMediaContent.types';

import s from './dish-media-content.module.scss';


type DishVideoSlideProps = {
    src: string,
    srcDesktop?: string,
    isActive: boolean,
    autoPlay: boolean,
    context: MediaContentContext,
    onClickOpenDetails: OnClickOpenDetails,
}


function PlayButton({
    isPlaing,
    handleClickPlayButton,
}: {
    isPlaing: boolean,
    handleClickPlayButton: React.MouseEventHandler<HTMLButtonElement>,
}) {
    if (isPlaing) return null;

    return (
        <button
            className="ny__dish__video-button"
            type="button"
            onClick={handleClickPlayButton}
        >
            <svg width="19" height="23" viewBox="-2 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11.5001L0.25 22.3254V0.674805L19 11.5001Z" fill="#91610D" />
            </svg>
        </button>
    );
}


export function DishVideoSlide({
    src,
    srcDesktop = undefined,
    isActive,
    autoPlay,
    context,
    onClickOpenDetails,
}: DishVideoSlideProps) {
    const videoRef = useRef<HTMLVideoElement>(null);

    const [isPlaing, setIsPlaying] = useState(false);

    const playVideo = useCallback(() => {
        const video = videoRef.current;

        if (video) {
            video.currentTime = 0;
            video.play();
            setIsPlaying(true);
        }
    }, []);

    const handleClickPlayButton = useCallback<React.MouseEventHandler<HTMLButtonElement>>((e) => {
        e.stopPropagation();
        e.preventDefault();
        playVideo();
    }, [playVideo]);


    useEffect(() => {
        if (isActive) return;

        setIsPlaying(false);

        const video = videoRef.current;
        if (video) {
            video.currentTime = 0;
            video.pause();
        }
    }, [isActive]);


    useEffect(() => {
        if (autoPlay) {
            playVideo();
        }
        // didMount - запускаем видео при маунте слайдера
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const rootClasses = classNames({
        ny__dish__video: true,
        vertical: src.includes('3839-3'),
    });


    return (
        <div className={rootClasses}>
            <video
                loop
                muted
                playsInline
                preload="metadata"
                className="ny__dish__image"
                ref={videoRef}
            >
                {srcDesktop ? (
                    <>
                        <source
                            media="(max-width: 1024px)"
                            src={`${src}#t=0.1`}
                            type="video/mp4"
                        />
                        <source
                            media="(min-width: 1024px)"
                            src={`${srcDesktop}#t=0.1`}
                            type="video/mp4"
                        />
                    </>
                ) : (
                    <source
                        media="(max-width: 1024px)"
                        src={`${src}#t=0.1`}
                        type="video/mp4"
                    />
                )}
            </video>
            {context === 'card' && (
                <button
                    type="button"
                    className={s.openDetailsButton}
                    onClick={onClickOpenDetails}
                >
                    open details
                </button>
            )}

            <PlayButton
                isPlaing={isPlaing}
                handleClickPlayButton={handleClickPlayButton}
            />
        </div>
    );
}
